import { ValidationError } from "sequelize"
import {
    CcLibraryHeading,
    CcLibraryHeadingCreate,
    CcLibraryHeadingSave,
    CcLibraryHeadingSaveResult,
} from "server/models"
import { GET, POST, DELETE, validate, search } from "client/store/utils"
import { LangType } from "client/store"
import { CcLibraryHeadingValidation } from "./types"


export const LoadCcLibraryHeadingById = (headingId: number) => (
    GET(`/ccLibraryHeading/id/${headingId}`)
    .then((heading: CcLibraryHeading) => heading)
)

export const SaveCcLibraryHeading = (
    id: number,
    heading: CcLibraryHeadingCreate,
    lang: LangType,
) => {
    const data: CcLibraryHeadingSave = {
        id,
        heading,
    }
    return POST(
        "/ccLibraryHeading/save",
        JSON.stringify(data),
    ).then(({ response, order }: CcLibraryHeadingSaveResult) => {
        const newHeading = response as CcLibraryHeading
        const error = response as ValidationError

        return {
            newHeadingId: newHeading.id || null,
            newOrder: order,
            validation: <CcLibraryHeadingValidation>validate(error, lang),
        }
    })
}

export const UpdateManyCcLibraryHeadings = (data: CcLibraryHeading[]) => (
    POST(
        "/ccLibraryHeading/updateMany",
        JSON.stringify(data),
    )
)

export const DeleteCcLibraryHeading = (headingId: number) => (
    DELETE(`/ccLibraryHeading/delete/${headingId}`)
    .then((removedRows: number) => removedRows)
)

export const DeleteManyCcLibraryHeadings = (headingIds: number[]) => (
    POST(
        "/ccLibraryHeading/deleteMany",
        JSON.stringify(headingIds),
    )
)

export const SearchCcLibraryHeadings = (
    headings: readonly CcLibraryHeading[],
    searchString: string,
) => (
    headings.filter((heading) => search(searchString, heading))
)
